@if (resolvedInitialLoading) {
  <div class="loading-container">
    <p-progressSpinner aria-label="Ładowanie danych" />
    <p>{{ loadingMessage }}</p>
  </div>
} @else if (showErrorState) {
  <div class="error-content">
    <i class="pi pi-exclamation-triangle error-icon"></i>
    <h3>{{ errorTitle }}</h3>
    <p>{{ resolvedErrorMessage }}</p>
    <button type="button" pButton class="retry-button" (click)="onRetry()">
      <i class="pi pi-refresh"></i>
      <span>{{ retryLabel }}</span>
    </button>
  </div>
} @else if (resolvedReady) {
  <section class="form-page-shell" [attr.aria-busy]="showContentOverlay">
    @if (resolvedRefreshing) {
      <div class="form-page-shell__refresh-indicator" role="status" aria-live="polite">
        <p-progressSpinner
          class="form-page-shell__refresh-spinner"
          [style]="{ width: '1.25rem', height: '1.25rem' }"
          strokeWidth="6"
          aria-label="Odświeżanie danych"
        />
        <span>{{ refreshingMessage }}</span>
      </div>
    }

    <div class="form-page-shell__content" [class.form-page-shell__content--blocked]="showContentOverlay">
      <div class="form-page-shell__content-body">
        <ng-content />
      </div>

      @if (showContentOverlay) {
        <div class="form-page-shell__overlay" aria-hidden="true">
          <p-progressSpinner
            [style]="{ width: '2rem', height: '2rem' }"
            strokeWidth="6"
          />
        </div>
      }
    </div>
  </section>
}
